export const eventsRouteNames = {
  Events: 'events/events',
  EventSingle: 'events/event-single',
  /** Event edit tab (nested under event manage). */
  EventDetail: 'events/event-detail',
  EventManageAttendees: 'events/event-manage-attendees',
  EventManageWaitlist: 'events/event-manage-waitlist',
}
